import { Box, Stack } from '@mui/material';
import { NamedLayoutBlock } from 'src/components';
import { PartnerHolidaysTable } from './partner-holidays-table';

export const HolidayScheduleView = () => {
  return (
    <NamedLayoutBlock
      title="Holiday Schedule"
      sx={{
        flex: 1,
        display: { sm: 'flex' },
      }}
    >
      <Stack spacing={2} sx={{ overflow: 'hidden', height: '100vh' }}>
        <Box sx={{ flexGrow: 1, overflow: 'auto', margin: '1rem 0' }}>
          <PartnerHolidaysTable />
        </Box>
      </Stack>
    </NamedLayoutBlock>
  );
};
